import type { ShopDisapprovalReasonDto } from "@babackapp/private-api-client/types";

type Translate = (key: string) => string;

/**
 * What to show as the reason of a past disapproval.
 *
 * Prefers the label frozen at the decision: a reason renamed since must not
 * rewrite the entry, which would leave a heading contradicting the message
 * under it. Falls back to the current configuration for entries written before
 * the label was stored, and says so when the reason is gone entirely.
 */
export function resolveReasonLabel(
  {
    reasonId,
    reasonLabel,
  }: { reasonId?: string | null; reasonLabel?: string | null },
  reasons: ShopDisapprovalReasonDto[],
  t: Translate,
): string {
  if (!reasonId) return t("returnDetail.disapproved.freeText");
  if (reasonLabel) return reasonLabel;

  const current = reasons.find((reason) => reason.id === reasonId);
  return current?.label ?? t("returnDetail.disapproved.deletedReason");
}

/** Whether anything was recorded at all — a reason alone counts, even when its
 * wording resolved to nothing. */
export function hasDisapprovalReason(params: {
  reasonId?: string | null;
  message?: string | null;
}): boolean {
  return Boolean(params.reasonId || params.message);
}
